/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';

export const buildGraphRubricsCacheKey = (tenantId, graphId) => `${tenantId}:${graphId}`;

const EvalGraphRubricsData = types
  .model('EvalGraphRubricsData', {
    optionsByCacheKey: types.optional(types.frozen(), {})
  })
  .views((self) => ({
    getOptions(tenantId, graphId) {
      if (!tenantId || !graphId) {
        return null;
      }
      const key = buildGraphRubricsCacheKey(tenantId, graphId);
      const options = self.optionsByCacheKey[key];
      return Array.isArray(options) ? options : null;
    }
  }))
  .actions((self) => ({
    setOptions(tenantId, graphId, options) {
      if (!tenantId || !graphId || !Array.isArray(options)) {
        return;
      }
      const key = buildGraphRubricsCacheKey(tenantId, graphId);
      applySnapshot(self, {
        ...getSnapshot(self),
        optionsByCacheKey: {
          ...self.optionsByCacheKey,
          [key]: options
        }
      });
    },
    clearAll() {
      applySnapshot(self, {
        ...getSnapshot(self),
        optionsByCacheKey: {}
      });
    }
  }));

export default EvalGraphRubricsData;
